export class Village {
    VillageName: string;
    VillageID: number;
    SubRegisterOffice: string;
    TotalSlots: number;
 
}

